import { styled } from '@mui/system';
import { Typography, Box } from '@mui/material';
import exclamationIcon from '../../../assets/exclamation-icon.svg';

export const ValidationSummary = styled(Box)({
  color: '#621b16',
  backgroundColor: '#FDECEA',
  padding: '16px',
  borderRadius: '4px',
  display: 'flex',
  alignItems: 'center',
  marginTop: '20px',
  flexWrap: 'wrap'
});

export const ExclamationIcon = styled(() => (
  <img src={exclamationIcon} alt='' />
))(() => ({}));

export const ErrorMessage = styled((props: any) => (
  <Typography variant='body2' {...props} />
))(() => ({
  marginLeft: '10px',
  flexBasis: '80%',
  fontWeight: 500
}));

export const ErrorList = styled(Box)({
  padding: '0 30px',
  listStyle: 'none',
  fontSize: '12px',
  color: '#621b16',
  margin: '5px 0',
});

export const ErrorListItem = styled(Box)({
  cursor: 'default',
  padding: '5px 0 0 0'
});